module.exports = __webpack_public_path__ + "img/yuedu.f13e874b.png";